module.exports = __webpack_public_path__ + "img/play-pause.1983ec34.svg";